<template>
  <div class="comp2-container">
    <div class="comp2-content" ref="historyContent">
      <div v-if="filteredHistoryVersions.length > 0">
        <div class="history-wheels-container">
          <div class="history-wheels-row">
            <div class="history-wheels-wheel-date"></div>
            <div v-for="phase in filteredPhases" :key="phase.code" class="history-wheels-phase">
              <p class="history-wheels-wheel-title">{{phase.code}}: {{phase.name}}</p>
              <p class="history-wheels-wheel-text">{{$t('global.wheelZoom')}}</p>
            </div>
          </div>
          <div v-for="version in filteredHistoryVersions" :key="version.code" class="history-wheels-row">
            <div class="history-wheels-wheel-date">
              <div class="history-wheels-wheel-date-box">{{version.date | formatDate}}</div>
            </div>
            <div v-for="phase in activePhaseIndexes" :key="phase" @click="showWheelInModal(phase, version)" class="column">
              <history-wheel ref="historyWheel" :data-version="version.date" class="history-wheels-wheel" :wheel="version.contentJson" :phaseIndex="phase"></history-wheel>
            </div>
          </div>
        </div>
        <div v-if="listViewHistory !== 'wheelsHistory'" class="history-details">
          <div v-for="phase in filteredPhases" :key="phase.code" class="history-details-phase-container">
            <div class="history-details-phase">
              <h3>{{phase.code}}: {{phase.name}}</h3>
            </div>

              <!-- Goals -->
              <div v-for="goal in filteredGoals(phase.code)" :key="goal.code" class="history-details-goal-container">
                <div class="history-details-goal">
                  <icon :name="goal.code" class="history-details-goal-icon"></icon>
                  <h4>{{goal.code}}: {{profileGoal(goal.code).title}}</h4>
                </div>

                <!-- targets -->
                <div class="history-details-targets">
                  <div v-for="target in profileGoalTargets(phase.index, goal.code)" :key="target.code" class="history-details-target">
                    <icon class="history-details-target-bullet" :class="['target-bullet-color-' + goal.code]" name="bullet"></icon>
                    <div class="tasks-content-targets-list-item-text">{{target.description}}</div>
                  </div>
                </div>

                <!-- tasks -->
                <div class="history-details-tasks">
                  <div v-for="(task, index) in filteredTasks(phase.index, goal.code)" :key="index" class="history-details-task">
                    <div class="history-details-task-header">
                      <icon class="history-details-task-header-icon" :class="['task-color-' + goal.code, {'task-selected': ((task.versions[task.versions.length - 1].how && task.versions[task.versions.length - 1].how.trim() !== '') && (task.versions[task.versions.length - 1].what && task.versions[task.versions.length - 1].what.trim() !== '')) || task.versions[task.versions.length - 1].custom}, {'task-notcustom': !task.versions[task.versions.length - 1].custom}]" :task="true" :phaseCode="phase.code" :taskCode="task.code" :name="goal.code"></icon>
                      <div class="history-details-task-header-text">
                        <div class="history-details-task-header-title">{{task.title}}</div>
                        <div class="history-details-task-header-description" v-html="task.description"></div>
                      </div>
                    </div>

                    <div v-for="(taskVersion, vIndex) in task.versions" :key="vIndex" style="border-bottom: 1px solid #eee;">
                      <div v-if="!taskVersion.deleted" class="columns history-details-task-data">
                        <div style="width: 50px; height: 50px; min-width: 50px;"></div>
                        <div class="column is-2">
                          <div v-show="vIndex === 0" class="history-details-task-data-label">{{$t('global.date')}}</div>
                          <span>{{taskVersion.date | formatDate}}</span>
                        </div>
                        <div class="column history-details-task-data-what">
                          <div v-show="vIndex === 0" class="history-details-task-data-label">{{$t('results.whatLabel')}}</div>
                          <span v-html="taskVersion.what"></span>
                        </div>
                        <div class="column history-details-task-data-how">
                          <div v-show="vIndex === 0" class="history-details-task-data-label">{{$t('results.howLabel')}}</div>
                          <span v-html="taskVersion.how"></span>
                        </div>
                        <div class="column is-2 history-details-task-data-completedpct">
                          <div v-show="vIndex === 0" class="history-details-task-data-label">{{$t('results.completedPctLabel')}}</div>
                          <completed-percent class="history-details-task-data-completedpct-slider" :percent="taskVersion.completedPct" :negative="taskVersion.negative" :color="goal.code"></completed-percent>
                          <div class="history-details-task-data-completedpct-value"><span v-if="taskVersion.negative">(</span>{{taskVersion.completedPct}}%<span v-if="taskVersion.negative">)</span></div>
                        </div>
                      </div>
                      <div v-else>
                        <div class="columns">
                          <div style="width: 50px; height: 50px; min-width: 50px;"></div>
                          <div class="column is-2">
                            <span>{{taskVersion.date | formatDate}}</span>
                          </div>
                          <div class="column">
                            <h3 style="opacity: 0.5;">{{$t('global.removed')}}</h3>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
        </div>
      </div>
      <div v-else class="full-height full-width flex-center">
        <icon class="giant-svg" name="sdg-wheel-black"></icon>
        <h2 style="margin-top: 10px;">{{$t('history.noVersionsSelected')}}</h2>
        <p>{{$t('history.selectVersions')}}</p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import historyWheel from './../shared/history-wheel/history-wheel'
import completedPercent from './../shared/completed-percent/completed-percent'
import getNextKey from './../../js/helpers/getNextKey'

export default {
  name: 'resultHistory',
  props: {
    showFilters: {
      type: Boolean,
      required: true
    },
    activeComponent: {
      type: String,
      required: true
    },
    setScroll: {
      type: Date
    },
    listViewHistory: {
      type: String,
      required: true
    }
  },
  components: {
    historyWheel,
    completedPercent
  },
  computed: {
    ...mapGetters({
      profile: 'getProfile',
      project: 'getProject',
      createPDF: 'getCreatePDF',
      profileGoal: 'getProfileGoal',
      versions: 'getProjectVersions',
      projectPhases: 'getProjectPhases',
      historyPhaseGoals: 'getHistoryPhaseGoals',
      profileGoalTargets: 'getProfileGoalTargets',
      activePhaseIndexes: 'getActivePhaseIndexes',
      profilePhaseIndex: 'getProfilePhaseIndex'
    }),
    filteredHistoryVersions () {
      return this.versions.filter(version => version.selected)
    },
    filteredPhases () {
      let phases = []
      for (let i = 0; i < this.projectPhases.length; i++) {
        if (this.activePhaseIndexes.includes(i)) {
          phases.push(this.projectPhases[i])
        }
      }
      return phases
    },
    sortedVersions () {
      return [...this.versions].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime())
    }
  },
  methods: {
    ...mapActions({
      setHistoryPDF: 'setHistoryPDF',
      setCreatePDF: 'setCreatePDF',
      setShowModal: 'setShowModal',
      setModalType: 'setModalType',
      setModalData: 'setModalData',
      clearVersions: 'clearVersions',
      setProjectVersions: 'setProjectVersions'
    }),
    showWheelInModal (phaseIndex, wheel) {
      let historyObject = {
        phase: phaseIndex,
        wheel: wheel
      }

      this.setShowModal(true)
      this.setModalType('history-wheel-modal')
      this.setModalData(historyObject)
    },
    filteredGoals (phaseCode) {
      let versions = this.filteredHistoryVersions
      let goalList = []
      let phaseIndex = this.profile.phases.findIndex(phase => phase.code === phaseCode)

      if (versions.length > 0) {
        for (let i = 1; i <= 17; i++) {
          let version = versions[versions.length - 1]
          let goal = version.contentJson.phases[phaseIndex].goals.find(goal => goal.code === i)

          if (goal) {
            goalList.push({
              goal: goal,
              code: goal.code,
              date: version.date,
              deleted: false
            })
          } else {
            if (versions.length > 1) {
              for (let v = versions.length - 2; v >= 0; v--) {
                version = versions[v]
                goal = version.contentJson.phases[phaseIndex].goals.find(goal => goal.code === i)

                if (goal) {
                  goalList.push({
                    goal: goal,
                    code: goal.code,
                    date: versions[v + 1].date,
                    deleted: true
                  })
                  break
                }
              }
            }
          }
        }
      }

      return goalList
    },
    filteredTasks (phaseIndex, goalCode) {
      let versions = this.filteredHistoryVersions
      let taskList = []

      if (versions.length > 0) {
        let profileGoal = this.profile.phases[phaseIndex].goals.find(goal => goal.code === goalCode)
        if (profileGoal) {
          for (let i = 1; i <= profileGoal.tasks.length; i++) {
            for (let version of versions) {
              let goal = version.contentJson.phases[phaseIndex].goals.find(goal => goal.code === goalCode)
              if (goal && goal.tasks) {
                if (goal.tasks.some(task => task.code === i.toString())) {
                  if (!taskList.includes(i.toString())) {
                    taskList.push(i.toString())
                    break
                  }
                }
              }
            }
          }

          let customTaskCode = 'A'
          let cont = true
          while (cont) {
            cont = false
            for (let version of versions) {
              let goal = version.contentJson.phases[phaseIndex].goals.find(goal => goal.code === goalCode)
              if (goal && goal.tasks) {
                if (goal.tasks.some(task => task.custom && task.code === customTaskCode)) {
                  cont = true
                  if (!taskList.includes(customTaskCode)) {
                    taskList.push(customTaskCode)
                    break
                  }
                }
              }
            }
            customTaskCode = getNextKey(customTaskCode)
          }
        }
      }

      taskList = taskList.map(taskCode => {
        let taskItem = {
          code: null,
          title: null,
          description: null,
          versions: []
        }

        for (let version of versions) {
          let foundGoal = version.contentJson.phases[phaseIndex].goals.find(goal => goal.code === goalCode)
          if (foundGoal) {
            let foundTask = foundGoal.tasks.find(task => task.code === taskCode)
            if (foundTask) {
              taskItem.code = taskCode
              taskItem.title = foundTask.title
              taskItem.description = foundTask.description
              let changed = taskItem.versions.length === 0
              let prev = taskItem.versions[taskItem.versions.length - 1]
              if (!changed) {
                changed = prev.whatOrg !== foundTask.what || prev.howOrg !== foundTask.how || prev.completedPct !== foundTask.completedPct
              }

              if (changed) {
                taskItem.versions.push({
                  what: (prev && prev.whatOrg) && (foundTask.what === prev.whatOrg) ? '&mdash; &#x3003; &mdash;' : foundTask.what,
                  how: (prev && prev.howOrg) && (foundTask.how === prev.howOrg) ? '&mdash; &#x3003; &mdash;' : foundTask.how,
                  whatOrg: foundTask.what,
                  howOrg: foundTask.how,
                  completedPct: foundTask.completedPct,
                  custom: foundTask.custom,
                  negative: foundTask.negative,
                  date: version.date,
                  deleted: false
                })
              }
            } else {
              if (taskItem.versions.length > 0 && !taskItem.versions[taskItem.versions.length - 1].deleted) {
                taskItem.versions.push({
                  date: version.date,
                  deleted: true
                })
              }
            }
          }
        }

        return taskItem
      })

      return taskList
    }
  },
  watch: {
    async createPDF (val, oldVal) {
      if (val && this.activeComponent === 'resultHistory') {
        if (this.filteredHistoryVersions.length > 0) {
          this.setCreatePDF(false)
          this.setShowModal(true)
          this.setModalType('create-pdf-modal')

          try {
            let lastProjectVersion = this.filteredHistoryVersions[this.filteredHistoryVersions.length - 1].contentJson
            let pdfObject = {
              profileId: this.project.profileId,
              baseUrl: window.location.href,
              details: JSON.stringify({
                name: lastProjectVersion.name,
                customer: lastProjectVersion.customer,
                responsible: lastProjectVersion.responsible,
                description: lastProjectVersion.description,
                comment: lastProjectVersion.comment,
                phases: lastProjectVersion.phases.filter(phase => (this.activePhaseIndexes.includes(this.profilePhaseIndex(phase.code)))).map(phase => {
                  return {
                    code: phase.code,
                    name: phase.name,
                    goals: this.filteredGoals(phase.code).map(goal => {
                      return {
                        code: goal.code,
                        tasks: this.filteredTasks(this.profilePhaseIndex(phase.code), goal.code)
                      }
                    })
                  }
                })
              }),
              resultWheels: this.filteredHistoryVersions.map(version => {
                return this.$refs.historyWheel.filter(wheel => wheel.$attrs['data-version'] === version.date).map(wheel => wheel.jsWheel.getSvgText())
              }),
              filter: JSON.stringify({
                versions: this.filteredHistoryVersions.map(version => version.date),
                showOnlyWheels: this.listViewHistory === 'wheelsHistory'
              })
            }
            await this.setHistoryPDF(pdfObject)
            this.setShowModal(false)
            this.setModalType(null)
          } catch (err) {
            console.log('error creating PDF', err)
            this.setCreatePDF(false)
          }
        }
      }
    },
    setScroll (val) {
      if (val) {
        this.$nextTick(() => {
          this.$refs.historyContent.scrollTop = 0
        })
      }
    }
  }
}
</script>
